import { useMemo, useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import styles from '@/components/Settings/GeneralSettingsContent.module.scss'
import { ACTIVE_SESSIONS_PLACEHOLDER, SESSIONS_PAGE_SIZE } from './generalSettingsConstants'
import { ActiveSessionsTableBody } from './ActiveSessionsTableBody'

export function ActiveSessionsTable() {
  const [page, setPage] = useState(0)
  const totalPages = Math.ceil(ACTIVE_SESSIONS_PLACEHOLDER.length / SESSIONS_PAGE_SIZE)
  const pageRows = useMemo(() => {
    const start = page * SESSIONS_PAGE_SIZE
    return ACTIVE_SESSIONS_PLACEHOLDER.slice(start, start + SESSIONS_PAGE_SIZE)
  }, [page])
  const rangeStart = page * SESSIONS_PAGE_SIZE + 1
  const rangeEnd = Math.min((page + 1) * SESSIONS_PAGE_SIZE, ACTIVE_SESSIONS_PLACEHOLDER.length)

  return (
    <>
      <ActiveSessionsTableBody rows={pageRows} />
      <Box className={styles.paginationRow}>
        <Typography component="p" className={styles.paginationMeta}>
          Showing {rangeStart}–{rangeEnd} of {ACTIVE_SESSIONS_PLACEHOLDER.length}
        </Typography>
        <Box className={styles.paginationControls}>
          <Button variant="outlined" size="small" disabled={page === 0} onClick={() => setPage((p) => Math.max(0, p - 1))}>
            Prev
          </Button>
          <Typography component="span" className={styles.paginationMeta}>
            {page + 1} / {totalPages}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            disabled={page >= totalPages - 1}
            onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
          >
            Next
          </Button>
        </Box>
      </Box>
      <Typography component="p" className={styles.sessionsFooter}>
        Session revocation may take up to 10 minutes to complete.
      </Typography>
    </>
  )
}
